import { render, staticRenderFns } from "./LawyerDetail.vue?vue&type=template&id=45648c44&scoped=true&"
import script from "./LawyerDetail.vue?vue&type=script&lang=js&"
export * from "./LawyerDetail.vue?vue&type=script&lang=js&"
import style0 from "./LawyerDetail.vue?vue&type=style&index=0&id=45648c44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45648c44",
  null
  
)

export default component.exports